'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(17, 17, 17, .5);\n  z-index: 9000;\n'], ['\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(17, 17, 17, .5);\n  z-index: 9000;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0px;\n  right: 0px;\n  padding:  ', ';\n  color:', ';\n  width: fit-content;\n  height: 100vh;\n  background-color: ', ';\n  border-left: 1px solid ', ';\n  box-shadow: 0px 0px 15px -5px rgb(0,0,0,.75);\n  z-index: 10000;\n'], ['\n  position: fixed;\n  top: 0px;\n  right: 0px;\n  padding:  ', ';\n  color:', ';\n  width: fit-content;\n  height: 100vh;\n  background-color: ', ';\n  border-left: 1px solid ', ';\n  box-shadow: 0px 0px 15px -5px rgb(0,0,0,.75);\n  z-index: 10000;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

require('../globalstyle');

var _renderprops = require('react-spring/renderprops');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Clickout = _styledComponents2.default.div(_templateObject);

var Div = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.padding || '20px';
}, function (props) {
  return props.color || 'black';
}, function (props) {
  return props.bg || 'white';
}, function (props) {
  return props.borderBg || 'black';
});

var Drawer = function Drawer(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick,
      open = _ref.open,
      bg = _ref.bg,
      color = _ref.color,
      padding = _ref.padding;


  return _react2.default.createElement(
    _renderprops.Transition,
    {
      items: open,
      from: { right: -200, opacity: 0 },
      enter: { right: 0, opacity: 1 },
      leave: { right: -200, opacity: 0 },
      config: { duration: 200 } },
    function (open) {
      return open && function (props) {
        return _react2.default.createElement(
          'div',
          { style: props },
          _react2.default.createElement(Clickout, { onClick: onClick }),
          _react2.default.createElement(
            Div,
            { style: props, className: className, bg: bg, color: color, padding: padding },
            children
          )
        );
      };
    }
  );
};

exports.default = Drawer;